<template>
  <div class="mobile-approval">
    <el-row class="fixed-row" type="flex" justify="space-around">
      <!-- <el-button type="primary" @click="vis_process = true">流程日志</el-button> -->
      <el-button type="success" @click="vis = true; editType = 'accept'" v-if="!$route.query.type">提交审批</el-button>
      <el-button type="warning" @click="rejectHandler" v-if="!$route.query.type">退回审批</el-button>
      <el-button type="warning" @click="revokeHandler" :disabled="lockbutton"
        v-if="showRevoke && $route.query.type == 'detail'">撤回审批</el-button>
    </el-row>
    <info-overview :item-info-id="itemInfoId" :detail="true" ref="middle"></info-overview>
    <!-- <el-dialog :visible.sync="vis_process" :width="this.detailLoading && this.vis_process ? '0' : '100vw'" top="5vh">
      <process-dialog @updateLockbutton="updateLockbutton" v-if="processInstId && processId" :inst-id="processInstId"
        :process-id="processId" :isAgreeShow.sync="isAgreeShow" :heightAuto="false"></process-dialog>
    </el-dialog> -->
    <el-dialog :visible.sync="vis" width="100vw" top="5vh" @close="closeHandler" :close-on-click-modal="false"
      v-loading="approvalLoading">
      <div class="title-text" style="margin-bottom: 20px">流程意见</div>
      <el-form>
        <el-form-item label="选择下一节点" v-show="editType !== 'reject' && nextList.length">
          <el-select v-model="next" @change="changeNext">
            <el-option v-for="item in nextList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择下一节点人员" v-show="showNext">
          <cascader-multiple class="mobile-cascader-input" :options="peopleList"
            :props="{ label: 'name', value: 'id', leaf: 'account', multiple: true }" v-model="people"
            :show-all-levels="false" filterable></cascader-multiple>
        </el-form-item>
        <el-form-item label="意见">
          <el-input type="textarea" placeholder="请输入意见" v-model="content" class="remark-input"></el-input>
        </el-form-item>
      </el-form>
      <el-row slot="footer" type="flex" justify="space-around">
        <el-button type="primary" @click="saveHandler('reject')" v-if="editType === 'reject'">确定</el-button>
        <template v-else>
          <el-button type="danger" @click="saveHandler(`end`)" v-if="isEndShow">终止</el-button>
          <el-button type="danger" @click="saveHandler(`N`)" v-if="!isAgreeShow">不同意</el-button>
          <el-button type="primary" @click="saveHandler(`Y`)">同意</el-button>
        </template>
        <el-button type="warning" @click="closeHandler">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import infoOverview from "./components/info_overview_mobile";
import CompanyApi, { CorporationApi } from "../../api/setup/index.js";
import processDialog from "./components/process_dialog";
import UserLogin from "@/api/LoginApi.js";
export default {
  name: "mobileApproval",
  components: {
    processDialog,
    infoOverview
  },
  data() {
    return {
      isEndShow: false, // 判断当前审批人是否是外事办
      isAgreeShow: false, // 在归档接收人，不需要展示【不同意】按钮
      itemInfoId: "",
      processId: "",
      processInstId: "",
      processList: [],
      peopleList: [], //下一节点人员列表
      people: [], //下一节点人员
      detailLoading: true,//为true时流程弹框加载但宽度设为0 因为页面初始化时要执行流程中关于是否可操作撤回按钮的相关逻辑 但是并不需要展示流程
      content: "",
      taskDefId: "",
      taskInstId: "",
      applicationId: "",
      vis: false,
      vis_process: true,
      info: {},
      next: null,
      nextNode: null,
      nextList: [],
      nodeList: [],
      authedNode: [],
      assignList: [],
      editType: "accept",
      approvalLoading: false,
      showRevoke: false,
      peopleTarget: null,
      lockbutton: false,
      targetTaskDefId: "",
      type: "approval",
    };
  },
  methods: {
    isGroupHandle() {
      let LoginApi = new UserLogin();
      LoginApi.getUserInfo({}).then(res => {
        let userDept = res.data.userDept;
        this.isEndShow = userDept.some(
          item => item.deptId == "1855060454393745409"
        );
      });
    },
    updateLockbutton(flag) {
      this.lockbutton = flag
    },
    changeNext(v) {
      this.nextNode = this.nodeList.find(a => a[0].key === v);
      this.people = [];
      if (this.nextNode && this.assignList.length) {
        for (let i of this.nextNode) {
          let target = this.assignList.find(a => a.key === i.key);
          if (target) {
            this.targetTaskDefId = i.key;
            this.peopleTarget = target;
            break;
          }
        }
      }
      if (this.peopleTarget) {
        let Api = new CorporationApi();
        Api.getOrganization({
          employeeParam: {
            orgEmployeeParam: {
              organizationIds: this.peopleTarget.assignee.dynamicUserConfig
                .rangeValue.deptIds
            }
          }
        }).then(res => {
          this.peopleList = this.remakeTree(res.data);
          // console.dir(this.peopleList)
        });
      }
    },
    remakeTree(tree) {
      for (let i of tree) {
        if (i.childs.length) {
          if (i.employees.length) {
            i.children = i.employees.concat(this.remakeTree(i.childs));
          } else {
            i.children = this.remakeTree(i.childs);
          }
        } else if (i.employees.length) {
          i.children = i.employees;
        } else {
          if (!i.account) {
            i.disabled = true;
          }
        }
      }
      return tree;
    },
    rejectHandler() {
      this.vis = true;
      this.editType = "reject";
    },
    //撤回审批 与pc端撤回功能同步
    revokeHandler() {
      this.$confirm("确认撤回审批吗?", '提示', {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "mobile-message-logout",
      }).then(() => {
        let Api = new CorporationApi()
        this.lockbutton = true
        Api.revokeFlow({ processId: this.processId, processInstId: this.processInstId, taskInstId: this.taskInstId, taskDefId: this.taskDefId }).then(res => {
          this.$message(res.msg)
          if (res.code == 1) {
            this.$router.push({ path: "/mobile-approval-list" })
          }
          else {
            this.lockbutton = false
          }
        })
      })
    },
    closeHandler() {
      this.content = "";
      this.vis = false;
      this.people = []
    },
    saveHandler(agree) {
      let Api = new CorporationApi();
      let data = {
        itemInfoId: this.itemInfoId,
        backable: "false",
        userRemark: this.content,
        taskInstId: this.taskInstId,
        taskDefId: this.taskDefId,
        agree,
        content: '',
        processInstId: this.processInstId,
        processId: this.processId,
        formModelData: {
          formId: this.info.form.id,
          applicationId: this.applicationId
        },
        dynamicParams: {
          assignationConditionModelIds: [this.next]
        }
      };
      if (!this.next && this.editType == "accept" && this.nextList.length) {
        this.$message({
          type: "error",
          message: "请选择下一个节点"
        });
        return;
      }
      if (this.showNext && !this.people.length) {
        this.$message({
          type: "error",
          message: "请选择下一个节点人员"
        });
        return;
      }
      // // 单选
      // let selPeople = this.people.slice(-1)
      // 多选
      let selPeople = this.people.map(val => val[val.length - 1])
      if (this.peopleTarget) {
        data.processInitiativeUsers = [
          {
            type: "1",
            initiativeTaskDefId: this.taskDefId,
            targetTaskDefId: this.targetTaskDefId,
            processInstId: this.processInstId,
            processId: this.processId,
            users: selPeople
          }
        ];
      } else if (this.people && this.people.length) {
        data.processInitiativeUsers = [
          {
            type: "1",
            initiativeTaskDefId: this.taskDefId,
            targetTaskDefId: this.targetTaskDefId,
            processInstId: this.processInstId,
            processId: this.processId,
            users: selPeople
          }
        ];
      }
      this.approvalLoading = true;
      if (this.editType == "accept") {
        if (agree === 'N') {
          if (!data.content) {
            data.content = data.content + "不同意";
          }
          this.$confirm("是否不同意审批?", "提示", {
            customClass: 'mobile-message-logout',
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            Api.submitTask(data).then(res => {
              this.approvalLoading = false;
              this.vis = false;
              this.content = '';
              if (res.code == 1) {
                this.$router.replace({
                  path: "/mobile-approval-list"
                });
              }
            }).catch(e => {
              this.approvalLoading = false
            })
          }).catch(() => {
            this.approvalLoading = false

          })
        } else if (agree === "Y") {
          if (!data.content) {
            data.content = data.content + "同意";
          }
          Api.submitTask(data).then(res => {
            this.approvalLoading = false;
            this.vis = false;
            this.content = '';
            if (res.code == 1) {
              this.$router.replace({
                path: "/mobile-approval-list"
              });
            }
          }).catch(e => {
            this.approvalLoading = false
          })
        } else {
          if (!data.content) {
            data.content = data.content + "终止";
          }
          Api.submitTask(data).then(res => {
            this.approvalLoading = false;
            this.vis = false;
            this.content = '';
            if (res.code == 1) {
              this.$router.replace({
                path: "/mobile-approval-list"
              });
            }
          }).catch(e => {
            this.approvalLoading = false
          })
        }
      } else {
        data.backable = "true";
        this.$confirm("是否确定退回审批?", "提示", {
          customClass: 'mobile-message-logout',
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          Api.submitTask(data).then(res => {
            this.approvalLoading = false;
            this.vis = false;
            if (res.code == 1) {
              this.$router.replace({
                path: "/mobile-approval-list"
              });
            }
          }).catch(e => {
            this.approvalLoading = false
          })
        }).catch(() => {
          this.approvalLoading = false;
        });

      }
    }
  },
  computed: {
    showNext: function () {
      // return this.authedNode.includes(this.next)
      if (this.next) {
        return this.assignList.length && this.editType !== 'reject' && this.authedNode.includes(this.next)
      } else {
        return this.assignList.length && this.editType !== 'reject' && !this.nextList.length
      }
    }
  },
  mounted() {
    this.itemInfoId = this.$route.query.businessId;
    let Api = new CorporationApi();
    //页面加载完成后 流程中关于是否可操作撤回按钮的相关逻辑已执行 此时弹窗可隐藏 弹窗高度复原
    this.detailLoading = false;
    this.vis_process = false;
    this.processId = this.$route.query.processId;
    this.processInstId = this.$route.query.processInstId;
    this.applicationId = this.$route.query.currentApp;
    this.taskDefId = this.$route.query.taskDefId;
    this.taskInstId = this.$route.query.taskInstId;
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    let timer = setInterval(() => {
      if (this.$refs.middle) {
        if (this.$refs.middle.basicInfo.status) {
          if (this.$refs.middle.basicInfo.status == 45) {
            this.showRevoke = true;
          }
          clearInterval(timer);
        }
      }
    }, 100);
    Api.getProcessInfo(this.applicationId).then(res => {
      this.info = res.data;
    });
    Api.getNodeDict().then(res => {
      this.authedNode = res.data
    })
    Promise.all([Api.getAssignation({ processId: this.processId, key: this.taskDefId }),
    Api.getCondition({ key: this.taskDefId, processId: this.processId })])
      .then(
        ([res1, res]) => {
          this.nextList = [];
          this.nodeList = res.data;
          this.assignList = res1.data
          for (let node of res.data) {
            for (let i of node) {
              
              if (i.dynamicConditionConfig) {
              if (i.dynamicConditionConfig.id) {
                this.nextList.push({
                  value: i.key,
                  label: i.text
                });
              }}
            }
          }
          if (!this.nextList.length && this.assignList.length) {
            this.targetTaskDefId = this.assignList[0].key;
            let Api = new CorporationApi();
            Api.getOrganization({
              employeeParam: {
                orgEmployeeParam: {
                  organizationIds: this.assignList[0].assignee.dynamicUserConfig
                    .rangeValue.deptIds
                }
              }
            }).then(res => {
              this.peopleList = this.remakeTree(res.data)
            });
          }
        }
      );
    this.isGroupHandle();
  }
};
</script>
<style lang="scss" scoped>
.mobile-approval {
  background-color: #f1f1f1;
  padding-bottom: 30px;

  /deep/ .el-dialog__close {
    color: #333;
  }


  /deep/ .el-dialog>.el-dialog__body {
    overflow: hidden;
  }

  .fixed-row {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 5px;
    right: 0px;
    background-color: #fff;
    box-shadow: 0 0 3px #ccc;
    z-index: 5;
  }
}
</style>
<style lang="scss">
@import "../../styles/mobile-cascader.scss";

.mobile-message-logout {
  width: 100vw;
}

.mobile-cascader-input {
  .el-cascader__label {
    font-size: 15px;
    line-height: 38px;
    padding-left: 15px;
  }
}
</style>
